<template>
  <div class="m-area pull-relative">
    <div
      class="c-wap-tabs"
      :style="{
        background: configStyle&&configStyle.formRowBgColor,
        color: configStyle&&configStyle.themeColor
      }"
    >
      <div class="tab-link" :class="{ active: !status }">
        <router-link
          :style="{ color: configStyle&&!status ? configStyle.themeColor : '#aaaaaa' }"
          :to="`/wap/meeting/${type}`"
        >
          我的全部会议</router-link
        >
      </div>
      <div class="tab-link" :class="{ active: status == 1 }">
        <router-link
          :to="`/wap/meeting/${type}/1`"
          :style="{ color: status == 1 ? configStyle&&configStyle.themeColor : '#aaaaaa' }"
          >未开始</router-link
        >
      </div>
      <div class="tab-link" :class="{ active: status == 2 }">
        <router-link
          :to="`/wap/meeting/${type}/2`"
          :style="{ color: status == 2 ? configStyle&&configStyle.themeColor : '#aaaaaa' }"
          >进行中</router-link
        >
      </div>
      <div class="tab-link" :class="{ active: status == 3 }">
        <router-link
          :to="`/wap/meeting/${type}/3`"
          :style="{ color: status == 3 ? configStyle&&configStyle.themeColor : '#aaaaaa' }"
          >已结束</router-link
        >
      </div>
    </div>
    <div class="m-wap-main">
      <van-list v-model="loading" :finished="finished" @load="getList">
        <div class="c-wap-meeting">
          <div
            class="meeting-items"
            :style="{
              'border-bottom': `1px solid ${
                configStyle&&configStyle.borderColor ? configStyle.borderColor : '#f2f2f2'
              }`
            }"
            v-for="o in list"
            :key="o.id"
          >
            <div class="image">
              <img :src="o.logoUrl || './images/logo.jpg'" alt="" />
            </div>
            <div class="content">
              <div class="name" :style="{ color: configStyle&&configStyle.formColor }">
                <a :href="o.nameHref" target="_blank">{{ o.name }}</a>
              </div>
              <div class="tag-wrap">
                <div
                  class="c-tag"
                  :class="{
                    proposed:
                      !o.status ||
                      o.status == 'proposed' ||
                      o.status == 'readytolaunch',
                    launched: o.status == 'launched',
                    completed: o.status == 'completed'
                  }"
                  :style="{
                    color:
                      o.status == 'proposed'
                        ? configStyle&&configStyle.mettingStatus.proposedColor
                        : o.status == 'launched'
                        ? configStyle&&configStyle.mettingStatus.launchedColor
                        : configStyle&&configStyle.mettingStatus.completedColor,
                    backgroundColor:
                      o.status == 'proposed'
                        ? proposedBgColor
                        : o.status == 'launched'
                        ? launchedBgColor
                        : completedBgColor
                  }"
                >
                  {{ statusJosn[o.status] || "未开始" }}
                </div>
                <div class="metting-type" v-if="type == 'webinar'">
                  {{ o.videoType == 1 ? "直播活动" : "点播活动" }}
                </div>
              </div>
              <div class="area-list" v-if="o.startTime && o.endTime">
                <span
                  class="icon icontemp time"
                  :style="{ color: configStyle&&configStyle.themeColor || '#1665d8' }"
                ></span>
                <span class="text">{{
                  (o.startTime || "--") +
                    (o.startTime ? "至" : "") +
                    (o.endTime || "")
                }}</span>
              </div>
              <div class="area-list" v-if="o.address">
                <span
                  class="icon icontemp area"
                  :style="{ color: configStyle&&configStyle.themeColor || '#1665d8' }"
                ></span>
                <span class="text">{{ o.address || "--" }}</span>
              </div>
            </div>
            <div class="goto" v-if="type == 'seminar'">
              <a :href="o.ticketUrlShort" target="_blank">
                <!-- <img src="../../assets/images/piao.png" /> -->
                <span
                  class="icon icontemp erweima"
                  :style="{ color: configStyle&&configStyle.themeColor }"
                ></span>
              </a>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="m-area u-mt40" v-if="!isLoading && list.length === 0">
      <a-empty description="暂无数据"></a-empty>
    </div>
    <!--    <div class="m-loading-data" v-if="isLoading"></div>-->
  </div>
</template>

<script>
import member from "../../services/member";
import { tenantId, sess, fileUrl } from "../../common/sbase";
import { cr } from "fire-wind-water/core";
import { $subscriber } from "fire-wind-water/tools/subscriber";
import moment from "moment";
export default {
  name: "Meeting",
  data() {
    return {
      keyword: "",
      type: "",
      status: "",
      current: 1,
      total: 0,
      pageSizeOptions: 20,
      isLoading: false,
      list: [],
      configStyle: null,
      webinar: {
        1: 1,
        2: 3,
        3: 4
      },
      seminar: {
        1: ["proposed", "readytolaunch"],
        2: ["launched"],
        3: ["completed"]
      },
      statusJosn: {
        proposed: "未开始",
        readytolaunch: "未开始",
        launched: "进行中",
        completed: "已结束"
      },
      loading: false,
      finished: false,
      unsubscribes: {
        seminar: null,
        webinar: null
      },
      proposedBgColor: "",
      launchedBgColor: "",
      completedBgColor: ""
    };
  },
  methods: {
    isLink(b) {
      if (this.type != this.$route.params.type) {
        this.keyword = "";
      }
      this.type = this.$route.params.type;
      this.status = this.$route.params.status;
      this.total = 0;
      this.current = 1;
      this.list = [];
      this.finished = false;
      if (!b) {
        this.getList();
      }
    },
    getWebinarList() {
      const info = {
        tenantId: tenantId,
        videoType: -1,
        keyword: this.keyword,
        sess: sess,
        webStatus: this.webinar[this.status] || -1,
        orderBy: "startTime",
        sort: "desc",
        start: (this.current - 1) * this.pageSizeOptions,
        num: this.pageSizeOptions
      };
      this.unsubscribes.webinar = member.webinarList(info).subscribe(data => {
        this.unsubscribes.webinar.unsubscribe();
        if (data.result == 0) {
          this.total = data.content.total;
          this.initList(data.content.items);
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    getSeminarList() {
      const info = {
        tenantId: tenantId,
        sess: sess,
        keyword: this.keyword,
        status: this.seminar[this.status] || -1,
        needTopic: 1,
        sortName: "startTime",
        sortOrder: "desc",
        start: (this.current - 1) * this.pageSizeOptions,
        num: this.pageSizeOptions
      };
      this.unsubscribes.seminar = member.seminarList(info).subscribe(data => {
        this.unsubscribes.seminar.unsubscribe();
        if (data.result == 0) {
          this.total = data.content.total || 0;
          this.initList(data.content.items || []);
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    initList(data) {
      this.isLoading = false;
      window.$sk.loading.hide();
      cr.each(data, d => {
        if (!d.name) {
          d.name = d.title;
        }

        if (d.startTime < 0) {
          d.startTime = null;
        }
        if (d.endTime < 0) {
          d.endTime = null;
        }
        d.startTime = d.startTime
          ? moment(d.startTime * 1000).format("YYYY-MM-DD HH:mm")
          : "";
        d.endTime = d.endTime
          ? moment(d.endTime * 1000).format("YYYY-MM-DD HH:mm")
          : "";
        if (this.type == "seminar") {
          d.nameHref = d.topicWap;
          d.logoUrl = d.logoRealPath
            ? `${fileUrl}?mappingId=${d.logoMapId}`
            : null;
        } else {
          d.nameHref = d.enterShortUrl;
          d.logoUrl = d.coverUrl;
          if (d.webStatus == 1) {
            d.status = "proposed";
          }
          if (d.webStatus == 3) {
            d.status = "launched";
          }
          if (d.webStatus == 4) {
            d.status = "completed";
          }
        }
        this.list.push(d);
      });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      if (
        (this.current - 1) * this.pageSizeOptions + this.pageSizeOptions >=
        this.total
      ) {
        this.finished = true;
      }
      this.current++;
    },
    search() {
      this.current = 0;
      this.getList();
    },
    onChange(current) {
      this.current = current;
      this.getList();
    },
    // 转换rgba模式
    toRgba(val, alpha) {
      var rgbaColor =
        "rgba(" +
        parseInt(val.slice(1, 3), 16) +
        ", " +
        parseInt(val.slice(3, 5), 16) +
        ", " +
        parseInt(val.slice(5, 7), 16) +
        ", " +
        alpha +
        ")";
      return rgbaColor;
    },
    getList() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      if (this.type == "webinar") {
        this.getWebinarList();
      } else {
        this.getSeminarList();
      }
    }
  },
  created() {

    this.isLink(true);
    $subscriber.subscribe("config-style", data=>{
      this.configStyle = data;
    });
    // 转换rgba模式
    var hexColor = this.configStyle.mettingStatus.proposedBgColor;
    var hexColor1 = this.configStyle.mettingStatus.launchedBgColor;
    var hexColor2 = this.configStyle.mettingStatus.completedBgColor;
    this.proposedBgColor = this.toRgba(hexColor, 0.14);
    this.launchedBgColor = this.toRgba(hexColor1, 0.12);
    this.completedBgColor = this.toRgba(hexColor2, 0.4);


  },
  mounted() {
    document.documentElement.style.setProperty(
      "--main-color",
      this.configStyle.themeColor || "#1665d8"
    );
  },
  watch: {
    $route: {
      handler: function() {
        this.isLink();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped>
:root {
  --main-color: #1665d8; /* 初始值 */
}
.c-wap-tabs .tab-link.active:after {
  background-color: var(--main-color);
}
</style>
